import { createFileRoute } from "@tanstack/react-router";

import { AgingPage } from "../../../features/purchasing/aging-page";

export const Route = createFileRoute("/_app/purchasing/payables")({ component: AgingPage });
